import { Action } from 'redux'
import * as Actions from './actionTypes'
import { Company } from '../models/company'
import { buildErrorAction, ErrorAction } from '../apiLoader/state/actions'
import { ActivityLog, ActivityLogtRecordsFilters } from '../models/activityLog'

export interface GetCompanyByIdAction extends Action {
    companyId: number
}
export interface GetCompanyByIdSuccessAction extends Action {
    company: Company
}
export const getCompanyByIdApi = (companyId: number): GetCompanyByIdAction => ({
    type: Actions.GET_COMPANY_API,
    companyId,
})
export const getCompanyByIdSuccess = (company: Company): GetCompanyByIdSuccessAction => ({
    type: Actions.GET_COMPANY_API_SUCCESS,
    company,
})
export const getCompanyByIdError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_COMPANY_API_ERROR,
    error,
)

export interface UpdateSettingsAction extends Action {
    settings: Object
}
export const getServiceOriginsApi = (settings: Object): UpdateSettingsAction => ({
    type: Actions.UPDATE_SETTINGS,
    settings,
})

export interface UpdateCompanyDataAction extends Action {
    company: Company
}
export interface UpdateCompanyDataSuccessAction extends Action {
    company: Company
}
export const updateCompanyDataApi = (company: Company): UpdateCompanyDataAction => ({
    type: Actions.UPDATE_COMPANY_DATA_API,
    company,
})
export const updateCompanyDataSuccess = (company: Company): UpdateCompanyDataSuccessAction => ({
    type: Actions.UPDATE_COMPANY_DATA_API_SUCCESS,
    company,
})
export const updateCompanyDataError = (error?: any): ErrorAction => buildErrorAction(
    Actions.UPDATE_COMPANY_DATA_API_ERROR,
    error,
)

export interface GetActivityLogRecordsAction extends Action {
    filters?: ActivityLogtRecordsFilters
}
export interface GetActivityLogRecordsSuccessAction extends Action {
    activityLogs: ActivityLog[]
}
export const getActivityLogRecordsApi = (filters: ActivityLogtRecordsFilters): GetActivityLogRecordsAction => ({
    type: Actions.GET_ACTIVITY_LOG_RECORDS_API,
    filters,
})
export const getActivityLogRecordsSuccess = (activityLogs: ActivityLog[]): GetActivityLogRecordsSuccessAction => ({
    type: Actions.GET_ACTIVITY_LOG_RECORDS_API_SUCCESS,
    activityLogs,
})
export const getActivityLogRecordsError = (error?: any): ErrorAction => buildErrorAction(
    Actions.GET_ACTIVITY_LOG_RECORDS_API_ERROR,
    error,
)